import React from 'react';
import blogImage from '../../../asstets/blog/blog.png';
import { api } from '../../../helpers';

const BlogMain = ({ blog }) => {
  if (blog === undefined) return <div>Loading...</div>;
  if (blog === null) {
    return (
      <div className="blog-main blog-main--empty">
        <p>No posts yet. Please check back later.</p>
      </div>
    );
  }

  const imageSrc = blog?.image
    ? `${api}/${String(blog.image).trim()}`
    : blogImage;

  return (
    <div className="blog-main">
      <img 
        src={imageSrc}
        alt="Main post" 
        className="blog-main__image" 
      />

      <h2 className="blog-main__title">{blog?.title}</h2>
      <p className="blog-main__date">
        {new Date(blog?.createdAt).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
      </p>

      <p className="blog-main__text">{blog?.content}</p>
    </div>
  );
};

export default BlogMain;
